import styled from "styled-components";

export const LottieWrapper = styled.div<{ safeAreaBottomPx?: number }>`
    width: 100%;
    line-height: 0;
    aspect-ratio: 360 / 129;
    padding-bottom: ${({ safeAreaBottomPx = 0 }) => safeAreaBottomPx}px;

    /* LottieAnimation renders a <button> internally */
    button {
        width: 100%;
        display: block;
        padding: 0;
        margin: 0;
        border: none;
        background: none;
    }

    svg {
        display: block;
        width: 100%;
    }
`;
